import {Injectable, Pipe, PipeTransform} from '@angular/core'

@Pipe({
  name: 'filterGroup'
})
@Injectable()
export class FilterGroupPipe implements PipeTransform {
  transform(grps: any[], args: any[]): any {
    return grps.filter(t => t.showGroup === true)
  }
}